/** 执法系统（platform-zf writ）UI 与业务常量 */

/** 执法会议类型：3=调查，4=调解（与仲裁 1/2 区分） */
export const HEARING_TYPE_INVESTIGATION = 3
export const HEARING_TYPE_ENFORCEMENT_MEDIATION = 4

export const ENFORCEMENT_HEARING_TYPE_OPTIONS = [
  { value: HEARING_TYPE_INVESTIGATION, label: '调查' },
  { value: HEARING_TYPE_ENFORCEMENT_MEDIATION, label: '调解' },
]

export const HEARING_TYPE_NAME = {
  1: '调解',
  2: '仲裁',
  3: '调查',
  4: '调解',
}

export const MIN_ENFORCEMENT_OFFICERS = 2

export const BRAND = {
  systemName: '行政执法线上平台管理系统',
  officer: '执法员',
  onlineEnforcement: '线上执法',
  enforcementRoom: '线上执法室',
}
